import React from "react"
import { Container, Row, Col } from "reactstrap"
import Img from "gatsby-image"
import { PageBannerWrap } from "./page-banner-area.stc"

const PageBannerArea = ({ bannerimage, banneralt }) => {
  return (
    <PageBannerWrap>
      <Container>
        <Row>
          <Col lg={12}>
            <Img fluid={bannerimage} banneralt={banneralt} />
          </Col>
        </Row>
      </Container>
    </PageBannerWrap>
  )
}

export default PageBannerArea
